import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import { ThemeProvider } from './context/ThemeContext';
import './styles/globals.css';

function ResumeRedirect() {
  useEffect(() => {
    window.location.replace('/Resume.pdf');
  }, []);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App relative min-h-screen">
          <div className="relative z-10">
            <SpeedInsights />
            <Analytics />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/resume" element={<ResumeRedirect />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
